import { render, staticRenderFns } from "./culturalStationItem.vue?vue&type=template&id=265a1b49&scoped=true&"
import script from "./culturalStationItem.vue?vue&type=script&lang=js&"
export * from "./culturalStationItem.vue?vue&type=script&lang=js&"
import style0 from "./culturalStationItem.vue?vue&type=style&index=0&id=265a1b49&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a1b49",
  null
  
)

export default component.exports